<template>
  <div>
    <v-row>
      <!-- <v-col cols="12" md="6">
        <h1>經費需求項目建立</h1>
      </v-col> -->
      <v-col cols="12" md="12" class="d-flex justify-end">
        <!-- <VBtn  v-if="form.projectId" @click="editSave" class="mr-2" variant="tonal" color="primary" >編輯儲存</VBtn>  -->
        <div
          v-if="
            form.status == flow[0].value &&
            !isDelete &&
            userDataCookie.userno == form.applyEmpNo
          "
        >
          <VBtn
            @click="editSave"
            v-if="form.projectId"
            class="mr-2"
            variant="tonal"
            color="primary"
            :loading="loadingBtn"
            >編輯儲存</VBtn
          >
          <VBtn
            @click="save"
            v-else
            class="mr-2"
            variant="tonal"
            color="primary"
            :loading="loadingBtn"
            >儲存</VBtn
          >
          <v-btn
            @click="deleteBtn"
            v-if="form.projectId"
            color="error"
            variant="tonal"
            class="mr-2"
            :loading="loadingBtn"
            >刪除</v-btn
          >
          <!-- <v-btn
            @click="save"
            v-if="form.projectId"
            color="secondary"
            variant="tonal"
            class="mr-2"
            >另存</v-btn
          > -->
          <v-btn 
            @click="send" 
            v-if="form.projectId" 
            class="mr-2"
            color="success"
            variant="tonal"
            :loading="loadingBtn"
          >
            送出
          </v-btn>
        </div>
        <div
          v-if="
            (form.status == flow[1].value || form.status == flow[5].value || form.status == flow[3].value) &&
            form.projectId
          "
        >
          <VBtn
            @click="revoke"
            v-if="
              userDataCookie.userno == form.applyEmpNo &&
              actionBtn.actions &&
              actionBtn.actions.ableToRevoke
            "
            class="mr-2"
            variant="tonal"
            color="error"
            :loading="loadingBtn"
            >收回</VBtn
          >
          <VBtn
            @click="reject"
            v-if="
              actionBtn && actionBtn.actions && actionBtn.actions.ableToReject
            "
            class="mr-2"
            variant="tonal"
            color="error"
            :loading="loadingBtn"
            >駁回</VBtn
          >
          <VBtn
            @click="approve"
            v-if="
              actionBtn && actionBtn.actions && actionBtn.actions.ableToApprove
            "
            class="mr-2"
            variant="tonal"
            color="primary"
            :loading="loadingBtn"
            >核准</VBtn
          >
        </div>
        <div
          v-if="
            form.status == flow[3].value &&
            userDataCookie.userno == form.applyEmpNo
          "
        >
          <VBtn
            @click="publish"
            class="mr-2"
            variant="tonal"
            color="success"
            :loading="loadingBtn"
            >發布</VBtn
          >
          <VBtn
            @click="close"
            class="mr-2"
            variant="tonal"
            color="primary"
            :loading="loadingBtn"
            >結案</VBtn
          >
        </div>
        <!-- <v-btn
          to="/tca/erm/ExpenseRequestProjectCenterList"
          color="secondary"
          variant="tonal"
          class="mr-2"
          >回清單</v-btn
        > -->
      </v-col>
    </v-row>

  <v-form ref="formRef">
    <v-row>
      <v-col cols="12" md="8">
        <v-card height="100%">
          <v-card-item class="h-100">
              <v-row class="h-100">
                <v-col cols="12">
                  <div class="text-subtitle-2">
                    項目名稱<span style="color: red; padding-left: 5px">*</span>
                  </div>
                  <v-text-field
                    v-model="form.projectTitle"
                    required
                    :rules="[rules.required]"
                    id="項目名稱"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" class="d-flex align-center">
                  <v-checkbox
                    v-model="form.is_gold"
                    label="黃金計畫"
                    id="黃金計畫"
                  ></v-checkbox>
                  <v-checkbox
                    v-model="form.fieldB"
                    label="大專院校體育總會"
                    id="大專院校體育總會"
                    false-value="N"
                    true-value="Y"
                  ></v-checkbox>
                </v-col>
                <v-col cols="12" md="4">
                  <div class="text-subtitle-2">
                    所屬年度<span style="color: red; padding-left: 5px">*</span>
                  </div>
                  <v-select
                    id="所屬年度"
                    v-model="form.belongYear"
                    :items="years"
                    :options="years"
                    item-title="text"
                    item-value="value"
                    required
                    :rules="[rules.required]"
                  ></v-select>
                </v-col>
                <v-col cols="12" md="4">
                  <div class="text-subtitle-2">
                    申請期間起<span style="color: red; padding-left: 5px"
                      >*</span
                    >
                  </div>
                  <AppDateTimePicker
                    id="申請期間起"
                    v-model="form.applicationPeriodStart"
                    placeholder=""
                    :config="{ maxDate:form.applicationPeriodEnd??'' }"
                    required
                    :rules="[rules.required]"
                    clearable
                  />
                </v-col>
                <v-col cols="12" md="4">
                  <div class="text-subtitle-2">
                    申請期間迄<span style="color: red; padding-left: 5px"
                      >*</span
                    >
                  </div>
                  <AppDateTimePicker
                    id="申請期間迄"
                    v-model="form.applicationPeriodEnd"
                    placeholder=""
                    :config="{ minDate: form.applicationPeriodStart??'' }"
                    required
                    :rules="[rules.required]"
                    clearable
                  />
                </v-col>
                <v-col cols="12">
                  <div class="text-subtitle-2">
                    公文上傳<span style="color: red; padding-left: 5px">*</span>
                  </div>
                  <!-- {{form.docFile}} -->
                  <!-- {{form.docFileId}} -->
                  <div
                    v-if="typeof form.docFile == 'string' && form.docFile"
                    class="d-flex justify-space-between"
                  >
                    <div class="d-flex align-center">
                      <v-icon icon="tabler-paperclip"></v-icon> 
                      <!-- <v-btn variants="plain" class="ml-2 bg-white"> -->
                        <a class="ml-2"
                          v-if="form.docFile"
                          target="_blank"
                           @click.prevent="getJwtBeforeRedirect(form.docFileId)" href=""
                          >{{ form.docFile }}</a
                        >
                      <!-- </v-btn> -->
                    </div>
                    <v-btn
                      class="bg-white"
                      color="black"
                      variants="text"
                      icon="tabler-x"
                      @click="clear('docFile')"
                    ></v-btn>
                  </div>
                  <VFileInput
                    id="公文上傳"
                    v-else
                    v-model="form.docFile"
                    required
                    @click:clear="handleClearFile('docFile')"
                    @change="handleOfficalPdfFile('docFile')"
                    :rules="[rules.required]"
                  ></VFileInput>
                </v-col>
                <v-col cols="12">
                  <div class="text-subtitle-2">相關附件</div>
                  <template v-if="typeof form.otherFile == 'string' && form.otherFile">
                    <div class="d-flex justify-space-between">
                      <div class="d-flex align-center">
                        <v-icon icon="tabler-paperclip"></v-icon>
                        <a class="ml-2" target="_blank" @click.prevent="getJwtBeforeRedirect(form.otherZipFile)" href="">
                          {{ form.otherFile }}
                        </a>
                      </div>
                      <v-btn class="bg-white" color="black" variants="text" icon="tabler-x" @click="clearMultiple('otherZipFile')"></v-btn>
                    </div>
                  </template>
                  <VFileInput 
                    v-else
                    counter 
                    show-size 
                    multiple 
                    v-model="form.otherFile"
                    @click:clear="clearMultiple('otherZipFile')"
                    @change="handleOfficalFileMultiple('otherZipFile')"
                  ></VFileInput> 
                </v-col>
              </v-row>
          </v-card-item>
        </v-card>
      </v-col>
      <v-col cols="12" md="4">
        <v-card class="h-100">
          <v-card-item class="h-100">
              <v-row>
                <UserInfo
                  :isShow="[true, true, true, true, false, false]"
                  :application-number="form.projectId"
                  :status="form.status"
                  :issue-date="form.publishDate"
                  :document-number="form.docNo"
                  :user-info="form.applyEmpNo"
                  status-component="ExpenseRequestProject"
                />
                <v-col cols="6">
                  <v-list-item>
                    <!-- <v-list-item-content> -->
                      <v-list-item-title>公文發文日期</v-list-item-title>
                      <v-list-item-subtitle>
                        <AppDateTimePicker id="公文發文日期" :rules="[rules.required]" :disabled="isDelete" v-model="form.publishDate" label="" placeholder="選擇公文日期"  />
                      </v-list-item-subtitle>
                    <!-- </v-list-item-content> -->
                  </v-list-item>
                </v-col>
                <v-col cols="6">
                  <v-list-item>
                    <!-- <v-list-item-content> -->
                      <v-list-item-title>公文號</v-list-item-title>
                      <v-list-item-subtitle>
                        <v-text-field id="公文號" v-model="form.docNo" :disabled="isDelete" :rules="[rules.required]" required></v-text-field>
                      </v-list-item-subtitle>
                    <!-- </v-list-item-content> -->
                  </v-list-item>
                </v-col>
                <v-col cols="12">
                  <v-list-item>
                    <!-- <v-list-item-content> -->
                    <v-list-item-title>通知協會</v-list-item-title>
                    <!-- <AssociationAutoComplete
                     v-model:select-array="form.notifyDeptNo"
                     :rules="[rules.required]"
                     /> -->
                    <v-btn @click="selectAllAss" variant="tonal" class="mb-2" size="small">選擇所有協會</v-btn>
                     <v-autocomplete
                      id="通知協會"
                      :custom-filter="customFilter"
                       v-model="form.notifyDeptNo"
                      :items="associations"
                      color="blue-grey-lighten-2"
                      item-title="depName"
                      item-value="depNo"
                      chips
                      label="選擇協會"
                      closable-chips
                      multiple
                      clearable
                      :rules="[rules.required]"
                      required
                    >
                      <template v-slot:chip="{ props, item }">
                        <v-chip
                          v-bind="props"
                          :text="item.raw.depName"
                        ></v-chip>
                      </template>
                      <template v-slot:item="{ props, item }">
                        <v-list-item
                          v-bind="props"
                          :subtitle="item.raw.depNo"
                          :title="item.raw.depName"
                        ></v-list-item>
                      </template>
                    </v-autocomplete>
                  </v-list-item>
                </v-col>
              </v-row>
          </v-card-item>
          </v-card>
        </v-col>
    </v-row>

    <v-row v-if="form.is_gold">
      <v-col cols="12">
        <v-card>
          <v-card-item>
            <v-row>
              <v-col cols="12" md="2">
                <div class="text-subtitle-2">生效日期</div>
                <AppDateTimePicker
                  id="生效日期"
                  :rules="[rules.required]"
                  v-model="form.effectiveDate"
                  placeholder="Select date"
                />
              </v-col>
              <v-col cols="12" md="2">
                <div class="text-subtitle-2">選手級別</div>
                <v-select
                  id="選手級別"
                :rules="[rules.required]"
                  v-model="form.athleteLevel"
                  :items="athletelevelList"
                  item-title="label"
                  item-value="value"
                ></v-select>
              </v-col>
              <v-col cols="12" md="2">
                <AppInput
                  id="所屬協會"
                :rules="[rules.required]"
                  v-model="form.belongDeptNo"
                  label="所屬協會"
                  type="picker"
                  placeholder="請輸入協會代碼"
                  :picker="duDepartmentPicker"
                  :query="{ orgType: 'A'}"
                  :disabled="false"
                />
              </v-col>
              <v-col cols="12" md="3">
                <div class="text-subtitle-2">會議記錄</div>
                <!-- <AppFileInput
                  v-model:file-id="form.meetingRecordId"
                  v-model:file-string="form.meetingRecord"
                  :rules="[rules.required]"
                  :disabled="isDelete"
                /> -->
                <div
                  v-if="
                    typeof form.meetingRecord == 'string' && form.meetingRecord
                  "
                  class="d-flex justify-space-between"
                >
                  <div class="d-flex align-center">
                    <v-icon icon="tabler-paperclip"></v-icon>
                      <a class="ml-2"
                        v-if="form.meetingRecord"
                        target="_blank"
                        @click.prevent="getJwtBeforeRedirect(form.meetingRecordId)" href=""
                        >{{ form.meetingRecord }}</a
                      >
                  </div>
                  <v-btn
                    class="bg-white"
                    color="black"
                    variants="text"
                    icon="tabler-x"
                    @click="clear('meetingRecord')"
                  ></v-btn>
                </div>
                <VFileInput
                  v-else
                  :rules="[rules.required]"
                  v-model="form.meetingRecord"
                  @click:clear="handleClearFile('meetingRecord')"
                  @change="handleOfficalFile('meetingRecord')"
                ></VFileInput>
              </v-col>
              <v-col cols="12" md="3">
                <div class="text-subtitle-2">黃金培訓計畫範例</div>
                <!-- <AppFileInput
                  v-model:file-id="form.goldPlanSampleFileId"
                  v-model:file-string="form.goldPlanSampleFile"
                  :rules="[rules.required]"
                  :disabled="isDelete"
                /> -->
                <div
                  v-if="
                    typeof form.goldPlanSampleFile == 'string' &&
                    form.goldPlanSampleFile
                  "
                  class="d-flex justify-space-between"
                >
                  <div class="d-flex align-center">
                    <v-icon icon="tabler-paperclip"></v-icon>
                      <a class="ml-2"
                      v-if="form.goldPlanSampleFile"
                       @click.prevent="getJwtBeforeRedirect(form.goldPlanSampleFileId)" href=""
                        target="_blank"
                        >{{ form.goldPlanSampleFile }}</a
                      >
                  </div>
                  <v-btn
                    class="bg-white"
                    color="black"
                    variants="text"
                    icon="tabler-x"
                    @click="clear('goldPlanSampleFile')"
                  ></v-btn>
                </div>
                <VFileInput
                  id="黃金培訓計畫範例"
                  v-else
                  :rules="[rules.required]"
                  v-model="form.goldPlanSampleFile"
                  @click:clear="handleClearFile('goldPlanSampleFile')"
                  @change="handleOfficalFile('goldPlanSampleFile')"
                ></VFileInput>
              </v-col>
            </v-row>
          </v-card-item>
        </v-card>
      </v-col>
    </v-row>
  </v-form>

    <v-row v-if="form.status==flow[1].value||form.status==flow[5].value">
      <v-col cols="12">
        <v-card>
          <v-card-item>
            <AppTextarea rows="1" auto-grow label="審查意見" placeholder="輸入審查意見" v-model="form.reviewComments"></AppTextarea>
          </v-card-item>
        </v-card>
      </v-col>
    </v-row>

    <v-row v-if="form.status !== flow[0].value">
      <v-col cols="12">
        <SignOffHistory :form-id="form.formId" :refresh="form.refreshFormId" />
        <!-- <v-data-table
        :headers="headers"
        :items="approvalHistory"
        class="elevation-1"
      >
        <template v-slot:top>
          <v-toolbar flat>
            <v-toolbar-title>簽核歷程</v-toolbar-title>
          </v-toolbar>
        </template>
        <template v-slot:item="{ item }">
          <tr>
            <td>{{ item.id }}</td>
            <td>{{ item.handler }}</td>
            <td>{{ item.handleTime }}</td>
            <td>{{ item.action }}</td>
            <td>{{ item.comment }}</td>
          </tr>
        </template>
      </v-data-table> -->
      </v-col>
    </v-row>
  </div>
</template>

<script setup lang="ts">
import { isDeepEqual } from "@antfu/utils";
import { reactive } from "vue";
import UserInfo from "../tnm/UserInfoComponent.vue";
import SignOffHistory from "../../../components/SignOffHistoryComponent.vue";
import AssociationAutoComplete from '../tnm/AssociationAutoCompleteComponenet.vue'

definePage({
  meta: {
    action: "manage", //固定為 manage
    subject: "EXPENSEREQUESTPROJECT", //系統代碼(系統授權設定中的系統代碼)
  },
});
const actionBtn = reactive({});
const fileUrl = useStorage("drFsUrl").value;
const flow = reactive([
  { key: "草稿", value: "Draft" },
  { key: "送出", value: "Submitted" },
  { key: "駁回", value: "Rejected" },
  { key: "核准", value: "Approved" },
  { key: "結案", value: "Closed" },
  { key: "擬准", value: "PreApproved" },  //
]);
const route = useRoute();
const editProject = reactive({});
const userDataCookie = useStorage('userData', {}).value
const isDelete = ref(false);
const loadingBtn = ref(false)
const form = reactive({
  refreshFormId: 0,
  formId: "",
  projectId: "", //經費需求項目主鍵
  projectTitle: "", //項目名稱
  is_gold: false, //是否為黃金計畫
  belongYear: null, //歸屬年度-西元
  applicationPeriodStart: "", //申請區間起
  applicationPeriodEnd: "", //申請區間迄
  docFile: null, //公文檔案
  docFileId: "", //公文檔案Id
  otherFile: [], //相關附件
  otherZipFile: "", //相關附件Id
  applyEmpNo: userDataCookie.userno, //申請人
  // applicationNumber: "",         //申請單號 (同PK)
  status: "Draft", //狀態
  publishDate: "", //公文日期
  docNo: "", //公文號
  notifyDeptNo: [], //通知單位
  effectiveDate: "", //生效日期
  athleteLevel: null, //選手級別
  meetingRecord: null, //會議記錄
  meetingRecordId: "", //會議記錄Id
  goldPlanSampleFile: null, //計畫範例
  goldPlanSampleFileId: "", //計畫範例Id
  reviewComments:'',      // 審核意見
  belongDeptNo:'', //所屬協會
  fieldB:'N', //大專院校體育總會
});
const notifyDeptNo = reactive(["中華民國羽球協會", "中華民國舉重協會"]);
// const athleteLevels=reactive(["第一級", "第二級"])
const menu = ref(false);
const menu2 = ref(false);
const headers = ref([
  { title: "#", key: "number" },
  { title: "處理人員", key: "cName" },
  { title: "處理時間", key: "processTime" },
  { title: "處理動作", key: "actionDesc" },
  { title: "簽核意見", key: "description" },
]);
const approvalHistory = reactive([]);
const formRef = ref(null); // 使用 ref 获取表单引用
const rules = ref({
  required: (value: any) => {
    if(Array.isArray(value)){
      return value.length>0 ||'此欄位為必填'
    }else{
      return !!value || '此欄位為必填'
    }
  },
});
const nowYear = new Date().getFullYear();
const westernYearToRocYear = (val: Number) => {
  let year = val - 1911;
  return year;
};
const years = reactive([
  { text: westernYearToRocYear(nowYear - 2), value: nowYear - 2 },
  { text: westernYearToRocYear(nowYear - 1), value: nowYear - 1 },
  { text: westernYearToRocYear(nowYear), value: nowYear },
  { text: westernYearToRocYear(nowYear + 1), value: nowYear + 1 },
  { text: westernYearToRocYear(nowYear + 2), value: nowYear + 2 },
]);
const popSwal = (icon,title,text) => {
  if(icon=="success"){
    $swal({
      position: 'top-end',
      icon: icon,
      title: title,
      text: text,
      showConfirmButton: false,
      timer: 1500,
      customClass: {
        confirmButton: 'btn btn-primary',
      },
      buttonsStyling: false,
    });
  }else if (icon=="error"){
    $swal({
      position: 'top-end',
      icon: icon,
      title: title,
      text: text,
      showConfirmButton: false,
      // timer: 1500,
      customClass: {
        confirmButton: 'btn btn-primary',
      },
      buttonsStyling: false,
    });
  }else{
    $swal({
      position: 'top-end',
      icon: icon,
      title: title,
      text: text,
      showConfirmButton: false,
      // timer: 1500,
      customClass: {
        confirmButton: 'btn btn-primary',
      },
      buttonsStyling: false,
    });
  }
}

// API----------------------------------
// JWT
const getJ = async()=>{
  const { data: jwt, execute: getJwt } = await useApi<any>(createUrl('/tca/file/get', {})) 
  return jwt
}
// 取得檔案 API
const getFile = async (code) => {
  // let apiUrl = useStorage('drFsUrl').value +'api/v2/files/public/'+ code + '/meta';
  let apiUrl = fileUrl + "/api/v2/files/public/" + code + "/meta";
  try {
    const resp = await $api(apiUrl, {
      method: "GET",
    });
    if (resp) {
      return resp;
    } else {
      console.error("Invalid response structure", resp);
      return null;
    }
  } catch (error) {
    console.error("API request failed", error);
    return null;
  }
};

// 上傳公文文件 API
const uploadPdfFile = async (files, val) => {
  try {
    const response = await $api(`/tca/docFile/upload`, {
      method: "POST",
      body: files,
    });
    form[val] = response.dto.fileId;
    form.publishDate = response.pubDate.replace(/\//g, '-');
    form.docNo = response.docNo;
  } catch (error) {
    popSwal('error',"上傳公文失敗",error.message || "請稍後再試")
  }
};
// 上傳文件 API
const uploadFile = async (files, val) => {
  try {
    const response = await $api(`/tca/file/upload`, {
      method: "POST",
      body: files,
    });
    form[val] = response.fileId;
    // console.log('File uploaded successfully', response.data);
  } catch (error) {
    popSwal('error',"上傳失敗",error.message || "請稍後再試")
  }
};
// 上傳文件-多檔
const uploadFileMultiple =async(files,val)=>{
  try {
    const response = await $api(`/tca/file/uploadFiles`, {
      method: 'POST',
      body: files,
    });
    form[val] = response.zipIdd
    // console.log('File uploaded successfully', response.data);
  } catch (error) {
    popSwal('error',"上傳失敗",error.message || "請稍後再試")
  }
}

// ATHLETELEVEL 選手級別 簡易共用表格
const { data: athletelevelList, execute: fetchAthletelevel } =
  await useApi<any>(
    createUrl("/q/de/select/select/select/deSelect", {
      query: {
        tabId: "ATHLETELEVEL",
      },
    })
  );

// 👉 通知協會API
const { data: subDeptsData, execute: fetchSubDept } = await useApi<any>(createUrl('/du/org/class/getSubDept', {
  query: {
    upperDepNo: 'asso' ,
  },
}))
const associations = computed(()=>{
  return subDeptsData.value?subDeptsData.value:[]
  }
)

// 取得API
const getProject = async (val) => {
  console.log("getProject");
  let projectId = val ? val : form.projectId;
  await $api("/tca/expenserequestproject/get", {
    method: "GET", //依據後端 restful api 的 method 設定
    query: {
      projectId,
    },
  }).then((resp) => {
    Object.assign(editProject, resp.data);
    // updateForm()
    // checkStage({
    //   projectId:resp.project.id,
    //   stage: "end"
    // })
    if (resp.data.status !== flow[0] && resp.data.formId) {
      getFormActions(resp.data.formId);
      form.refreshFormId++
    }
    // if(resp.project.formId){
    //   project.refreshFormId++
    // }
  });
};
// 取得可執行動作API
const getFormActions = async (formId) => {
  let apiUrl = "/form/getFormActions/" + formId;
  await $api(apiUrl, {
    method: "GET",
  })
    .then((resp) => {
      if (resp) {
        Object.assign(actionBtn, resp);
      } else {
        console.error("Invalid response structure", resp);
      }
      console.log(actionBtn);
    })
    .catch((error) => {
      console.error("API request failed", error);
    });
};

// 儲存API
const saveProjrect = async (body) => {
  loadingBtn.value= true
  await $api("/tca/expenserequestproject/save", {
    method: "POST",
    body: body,
  }).then((resp) => {
    if(resp.statusCode == 200){
      popSwal('success',resp.message,"儲存")
      getProject(resp.data.projectId);
    }else{
      popSwal('error',resp.message,"")
    }
    loadingBtn.value= false
  });
};
// 刪除API
const deleteProjrect = async (val) => {
  loadingBtn.value= true
  let projectId = val ? val : form.projectId;
  await $api("/tca/expenserequestproject/delete", {
    method: "DELETE",
    query: {
      projectId,
    },
  }).then((resp) => {
    if(resp.statusCode == 200){
      popSwal('success',resp.message,"刪除")
      isDelete.value = true;
    }else{
      popSwal('error',resp.message,"")
    }
    loadingBtn.value= false
  });
};
// 送出API
const submitProjrect = async (val) => {
  loadingBtn.value= true
  let projectId = val ? val : form.projectId;
  let apiUrl = "/tca/expenserequestproject/submit";
  await $api(apiUrl, {
    method: "POST",
    query: {
      projectId,
    },
  }).then((resp) => {
    if(resp.statusCode == 200){
      popSwal('success',resp.message,"送出")
      getProject(resp.data.projectId);
    }else{
      popSwal('error',resp.message,"")
    }
    loadingBtn.value= false
  })
};
// 收回API
const revokeProjrect = async (val) => {
  loadingBtn.value= true
  let projectId = val ? val : form.projectId;
  let apiUrl = "/tca/expenserequestproject/revoke";
  await $api(apiUrl, {
    method: "POST",
    query: {
      projectId,
    },
  }).then((resp) => {
    if(resp.statusCode == 200){
      popSwal('success',resp.message,"收回")
      getProject()
    }else{
      popSwal('error',resp.message,"")
    }
    loadingBtn.value= false
  });
};
// 駁回API
const rejectProjrect = async (body) => {
  loadingBtn.value= true
  let apiUrl = "/tca/expenserequestproject/reject";
  await $api(apiUrl, {
    method: "POST",
    body: body,
  }).then((resp) => {
    if(resp.statusCode == 200){
      popSwal('success',resp.message,"駁回")
      getProject();
    }else{
      popSwal('error',resp.message,"")
      loadingBtn.value= false
    }
  });
};
// 核准API
const approveProjrect = async (body) => {
  loadingBtn.value= true
  let apiUrl = "/tca/expenserequestproject/approve";
  await $api(apiUrl, {
    method: "POST",
    body: body,
  }).then((resp) => {
    if(resp.statusCode == 200){
      popSwal('success',resp.message,"核准")
      getProject();
    }else{
      popSwal('error',resp.message,"")
    }
    loadingBtn.value= false
  });
};
// 發布API
const publishProjrect = async (val) => {
  loadingBtn.value= true
  let projectId = val ? val : form.projectId;
  let apiUrl = "/tca/expenserequestproject/publish";
  await $api(apiUrl, {
    method: "POST",
    query: {
      projectId,
    },
  }).then((resp) => {
    if(resp.statusCode == 200){
      popSwal('success',resp.message,"發布")
      getProject();
    }else{
      popSwal('error',resp.message,"")
    }
    loadingBtn.value= false
  });
};
// 結案API
const closeProjrect = async (val) => {
  loadingBtn.value= true
  let projectId = val ? val : form.projectId;
  let apiUrl = "/tca/expenserequestproject/closedProject";
  await $api(apiUrl, {
    method: "POST",
    query: {
      projectId,
    },
  }).then((resp) => {
    if(resp.statusCode == 200){
      popSwal('success',resp.message,"結案")
      getProject();
    }else{
      popSwal('error',resp.message,"")
    }
    loadingBtn.value= false
  });
};
// --------------------------------------API
// file download
const getJwtBeforeRedirect = async (fileId) => {
  const jwt = await getJ();  // 获取新的 JWT
  let url = `${fileUrl}/api/v2/files/nstc/${fileId}?drJwt=${jwt.value}`;
  console.log(url)
  // 打开新链接
  window.open(url, '_blank');
};

const selectAllAss =() =>{
  let arr = associations.value.map(item => item.depNo)
  form.notifyDeptNo = arr
}

const customFilter =(itemTitle, queryText, item)=> {
  const textOne = item.raw.depName.toLowerCase()
  const textTwo = item.raw.depNo.toLowerCase()
  const searchText = queryText.toLowerCase()
  return textOne.indexOf(searchText) > -1 || textTwo.indexOf(searchText) > -1
}

// handle Btn
// 清除文基案input
const handleClearFile = (val) => {
  form[val] = "";
  form[val + "Id"] = "";
};

// 上傳公文
const handleOfficalPdfFile = (val) => {
  if (form[val]) {
    const formData = new FormData();
    form[val].forEach((file, index) => {
      formData.append("file", file);
    });
    // API包含公文號及公文日期
    uploadPdfFile(formData, val + "Id");
  }
};
// 上傳文件
const handleOfficalFile = (val) => {
  if (form[val]) {
    // let arr =[]
    const formData = new FormData();
    form[val].forEach((file, index) => {
      formData.append("file", file);
    });
    uploadFile(formData, val + "Id");
  }
};
// 上傳文件 - 多檔
const handleOfficalFileMultiple = (val) => {
  let key  = val.replace('Zip','')
  if (form[key]) {
    // let arr =[]
    const formData = new FormData();
    form[key].forEach((file, index) => {
      formData.append("multiFiles", file);
    });
    uploadFileMultiple(formData, val);
  }
};

// 清除file 及fileId
const clear = (fileName) => {
  form[fileName] = "";
  form[fileName + "Id"] = "";
};
// 清除file 及fileId - 多檔
const clearMultiple = (fileName) => {
  let key = fileName.replace('Zip','')
  form[fileName] = "";
  form[key] = [];
};
// validate formRef
const submit = async () => {
  const { errors, valid } = await formRef.value.validate();
  if (!valid) {
    const errorsIds = errors.map(item => item.id)
    $popSwal('error', '請填寫完整資訊',`請填寫\n${errorsIds}`);
    return false;
  }
  if(!!form.is_gold && form.fieldB=="Y"){
    $popSwal('error', '錯誤',`不可同時勾選黃金計畫及大專院校體育總會`);
    return false;
  }
  return valid;
};
const saveBody = () =>{
  console.log(form.publishDate)
  let body = {
    projectId: form.projectId,
    projectTitle: form.projectTitle,
    // applyFormId: "",
    otherZipFile: form.otherZipFile,
    docNo: form.docNo,
    publishDate: rocToWestern(form.publishDate, "-", "-"),
    notifyDeptNo: form.notifyDeptNo.toString(), 
    docFile: form.docFileId,
    // planSampleFile": "string",
    is_gold: form.is_gold ? "Y" : "N",
    // projectType": "",  ???
    effectiveDate: form.effectiveDate?rocToWestern(form.effectiveDate, "", "-"):'',
    athleteLevel: form.athleteLevel,
    // memberName": ,  ????
    meetingRecord: form.meetingRecordId,
    belongYear: form.belongYear,
    applyStartDate: form.applicationPeriodStart?rocToWestern(form.applicationPeriodStart, "", "-"):'',
    applyEndDate: form.applicationPeriodEnd?rocToWestern(form.applicationPeriodEnd, "", "-"):'',
    applyEmpNo: form.applyEmpNo,
    status: form.status,
    goldPlanSampleFile: form.goldPlanSampleFileId,
    belongDeptNo:form.belongDeptNo,
    fieldB:form.fieldB??'N',
  };
  return body
}
//儲存btn
const save = async () => {
  const submitConfirm = await submit();
  if(!submitConfirm) return
  if (form.publishDate && form.docNo) {
    if (submitConfirm) {
      const body = await saveBody()
      body.projectId=""
      body.applyEmpNo=userDataCookie.userno
      body.status=flow[0].value
      saveProjrect(body);
    }
  } else {
    popSwal('error','確認公文發文日期及公文號','')
  }
};
//editSavebtn  編輯儲存按鈕
const editSave = async () => {
  const submitConfirm = await submit();
  if(!submitConfirm) return
  if (form.publishDate && form.docNo) {
    if (submitConfirm) {
      const body = await saveBody()
      saveProjrect(body);
    }
  } else {
    popSwal('error','確認公文發文日期及公文號','')
  }
};

const updateStatusData = () =>{
  let body ={
    projectId:form.projectId,
    opinions:form.reviewComments,
  }
  return body
}

//deleteBtn btn 刪除按鈕
const deleteBtn = async () => {
  $swal({
    title: `刪除資料`,
    text: `${form.projectId}`,
    showCancelButton: true,
    confirmButtonText: "我要刪除",
    cancelButtonText: "取消",
  }).then(async(result) => {
  /* Read more about isConfirmed, isDenied below */
    if (result.isConfirmed) {
      deleteProjrect(form.projectId);
    }
  });
};
//send btn 送出按鈕
const send = async () => {
  submitProjrect(form.projectId);
};
//revoke btn 收回按鈕
const revoke = async () => {
  revokeProjrect(form.projectId);
};
//reject btn 駁回按鈕
const reject = async () => {
   $swal({
    title: `駁回資料`,
    text: `${form.projectId}`,
    showCancelButton: true,
    confirmButtonText: "我要駁回",
    cancelButtonText: "取消",
  }).then(async(result) => {
  /* Read more about isConfirmed, isDenied below */
    if (result.isConfirmed) {
      const body = await updateStatusData()
      rejectProjrect(body);
    }
  });
};
//approve btn 核准按鈕
const approve = async () => {
  const body = await updateStatusData()
  approveProjrect(body);
};
//publish btn 結案按鈕
const publish = async () => {
  publishProjrect(form.projectId);
};
//close btn 結案按鈕
const close = async () => {
  closeProjrect(form.projectId);
};

const updateForm = () => {
  form.projectId = editProject.projectId;
  form.projectTitle = editProject.projectTitle;
  form.is_gold = editProject.is_gold == "Y" ? true : false;
  form.belongYear = Number(editProject.belongYear);
  form.applicationPeriodStart = westernToRoc(
    westernToFormat(editProject.applyStartDate, "-"),
    "-",
    "-"
  );
  form.applicationPeriodEnd = westernToRoc(
    westernToFormat(editProject.applyEndDate, "-"),
    "-",
    "-"
  );
  // 公文檔案
  form.docFileId = editProject.docFile;
  form.docFile = editProject.docFileName;
  // 相關附件
  form.otherZipFile = editProject.otherZipFile;
  form.otherFile = editProject.otherFile?editProject.otherFile:(editProject.otherZipFile?editProject.otherZipFile:[]);
  form.applyEmpNo = editProject.applyEmpNo;
  form.status = editProject.status;
  form.publishDate = westernToRoc(editProject.publishDate, "-", "-");
  form.docNo = editProject.docNo;
  form.effectiveDate = westernToRoc(
    westernToFormat(editProject.effectiveDate, "-"),
    "-",
    "-"
  );
  form.athleteLevel = editProject.athleteLevel;
  // 會議記錄
  form.meetingRecordId = editProject.meetingRecord?editProject.meetingRecord:'';
  form.meetingRecord = editProject.meetingRecordName?editProject.meetingRecordName:'';
  // 計畫範例
  form.goldPlanSampleFileId = editProject.goldPlanSampleFile?editProject.goldPlanSampleFile:'';
  form.goldPlanSampleFile = editProject.goldPlanSampleFileName?editProject.goldPlanSampleFileName:'';
  form.belongDeptNo=editProject.belongDeptNo;
  form.formId = editProject.formId;
  if(editProject.notifyDeptNo&&editProject.notifyDeptNo.length>0){
    form.notifyDeptNo.splice(0,form.notifyDeptNo.length, ...editProject.notifyDeptNo.split(','))
  }else{
    form.notifyDeptNo.splice(0,form.notifyDeptNo.length)
  }
  form.fieldB = editProject.fieldB??'N';
};

watch(editProject, async () => {
  updateForm();
  // if (editProject.docFile) {
  //   let docFile = await getFile(editProject.docFile);
  //   form.docFile = docFile.fileName;
  // }
  // if (editProject.attachment) {
  //   let attachment = await getFile(editProject.attachment);
  //   console.log(attachment.fileName);
  //   form.relatedAttachment = attachment.fileName;
  // }
  // if (editProject.meetingRecord) {
  //   let meetingRecord = await getFile(editProject.meetingRecord);
  //   form.meetingRecord = meetingRecord.fileName;
  // }
  // if (editProject.goldPlanSampleFile) {
  //   let goldPlanSampleFile = await getFile(editProject.goldPlanSampleFile);
  //   form.goldPlanSampleFile = goldPlanSampleFile.fileName;
  // }
});

// 使用 watch 監控查詢參數變化
watch(
  () => route.query.projectId,
  async (newValue) => {
    if (newValue !== form.projectId) {
      form.projectId = newValue || "";
      getProject(form.projectId);
    }
  }
);

// onMounted 用來初始化數據
onMounted(() => {
  form.projectId = route.query.projectId || "";
  if (route.query.projectId) {
    getProject(route.query.projectId);
  }
});
</script>

<style scoped>
.bg-white {
  background: none !important;
  box-shadow: none !important;
}
</style>
